import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Pages publiques exposées en URL propre (sans /api). Les back-offices
// (admin, backoffice, finance, logistique, assurance, bo/*) restent sur /api.
const PUBLIC_PAGES = [
  "accueil",
  "homepage",
  "vitrine",
  "apropos",
  "contact",
  "advert",
  "adverts",
  "pub-mobile",
  "devenir-acheteur",
  "catalogue",
  "club",
  "fresh",
  "evaluation",
  "group",
  "signal",
  "sissakedeh",
  "marchand",
  "marchand-app",
  "producteur-app",
  "acheteur",
  "portail",
  "gestion",
  "demo",
  "login",
  "preview",
  "entreprise/inscription",
  "entreprise/verification",
  "entreprise/bienvenue",
  "entreprise/premier-produit",
  "entreprise/demande-recue",
  "entreprise/equipe",
  "entreprise/catalogue/nouveau",
  "entreprise/catalogue",
  "legal/cgu",
  "legal/confidentialite",
  "mentions-legales",
  "investor/pitch",
  "investor",
];

// Chemins propres particuliers -> chemin backend réel
const SPECIAL_MAP = {
  "/": "/api/accueil",
  "/accueil": "/api/accueil",
  "/homepage": "/api/homepage",
  "/cgu": "/api/legal/cgu",
  "/confidentialite": "/api/legal/confidentialite",
  // Back-offices servis en URL propre sur le domaine principal (Option 1 : path-based).
  "/office": "/api/admin",
  "/finance": "/api/finance/login",
  "/logistique": "/api/logistics/login",
  "/assurance": "/api/assurance/login",
  // Espace Investisseurs : URL publique au pluriel /investors
  "/investors": "/api/investor",
  "/investors/pitch": "/api/investor/pitch",
};

// Chemins back-office : on affiche le HTML renvoyé meme si le statut n'est pas 200
// (ex : page "Service temporairement indisponible" en 503) au lieu de rediriger.
const BO_PATHS = new Set(["/office", "/finance", "/logistique", "/assurance"]);

function resolveBackendPath(pathname) {
  if (SPECIAL_MAP[pathname]) return SPECIAL_MAP[pathname];
  // Défaut : préfixer par /api (couvre /apropos, /entreprise/inscription, /legal/cgu, /p/xxx...)
  return "/api" + pathname;
}

// Réécrit les liens des pages publiques /api/<x> -> /<x> pour garder des URLs propres
// pendant la navigation. Les assets (/api/bo-theme.css, /api/img/...) et les
// back-offices (/api/admin, /api/backoffice...) ne sont PAS touchés.
function rewritePublicLinks(html) {
  let out = html;
  for (const p of PUBLIC_PAGES) {
    out = out.split(`href="/api/${p}"`).join(`href="/${p}"`);
  }
  // Ancienne nomenclature "vitrine" -> nouvelle URL d'accueil (FR).
  out = out.split(`href="/api/vitrine"`).join(`href="/accueil"`);
  out = out.split(`href="/vitrine"`).join(`href="/accueil"`);
  out = out.split(`href="/api/legal/cgu"`).join(`href="/cgu"`);
  out = out.split(`href="/api/legal/confidentialite"`).join(`href="/confidentialite"`);
  return out;
}

function App() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const pathname = window.location.pathname;
    // Anciennes adresses -> nouvelle page officielle.
    if (pathname === "/pub-mobile" || pathname === "/pubmobile") {
      window.location.replace("/adverts");
      return;
    }
    // Renommage : /vitrine -> /accueil (redirection permanente côté public).
    if (pathname === "/vitrine") {
      window.location.replace("/accueil");
      return;
    }
    // Ancienne URL sans "s" -> URL officielle /adverts.
    if (pathname === "/advert") {
      window.location.replace("/adverts");
      return;
    }
    const isBO = BO_PATHS.has(pathname);
    const backendPath = resolveBackendPath(pathname);
    fetch(`${BACKEND_URL}${backendPath}`, { cache: "no-store" })
      .then((r) => r.text().then((html) => ({ ok: r.ok, status: r.status, html })))
      .then(({ ok, status, html }) => {
        // Pour un back-office, on affiche toujours le HTML (y compris la page 503).
        if (!ok && !isBO) throw new Error(`HTTP ${status}`);
        const rewritten = rewritePublicLinks(html);
        document.open();
        document.write(rewritten);
        document.close();
      })
      .catch((e) => {
        if (window.location.pathname !== "/") {
          window.location.replace("/");
          return;
        }
        setError(e.message);
      });
  }, []);

  return (
    <div
      data-testid="public-page-loader"
      style={{
        minHeight: "100vh",
        background: "#F2EEE6",
        display: error ? "flex" : "block",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        color: "#001233",
      }}
    >
      {error ? `Page indisponible (${error})` : ""}
    </div>
  );
}

export default App;
